var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Action/assignment_black_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Indicator/Sync/Offline-Copy",
    transform: "translate(-28.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 22.0000001 0 22.0000001 22.0000001 0 22.0000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5833334,2.75000001 L4.58333335,2.75000001 C3.56583335,2.75000001 2.75000001,3.57500002 2.75000001,4.58333335 L2.75000001,17.4166667 C2.75000001,18.4250001 3.56583335,19.25 4.58333335,19.25 L17.4166667,19.25 C18.4250001,19.25 19.25,18.4250001 19.25,17.4166667 L19.25,6.4166667 L15.5833334,2.75000001 Z M17.4166667,17.4166667 L4.58333335,17.4166667 L4.58333335,4.58333335 L14.8225001,4.58333335 L17.4166667,7.17750003 L17.4166667,17.4166667 Z M11.0000001,11.0000001 C9.47833338,11.0000001 8.25000004,12.2283334 8.25000004,13.7500001 C8.25000004,15.2716667 9.47833338,16.5000001 11.0000001,16.5000001 C12.5216667,16.5000001 13.75,15.2716667 13.75,13.7500001 C13.75,12.2283334 12.5216667,11.0000001 11.0000001,11.0000001 Z M5.50000003,5.50000003 L13.7500001,5.50000003 L13.7500001,9.16666671 L5.50000003,9.16666671 L5.50000003,5.50000003 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
export default SvgSave24Dp;